import { Suspense } from 'react';
import { useAllData } from '../data/loaders';

function BuildInfo() {
  const data = useAllData();
  const date = new Date(data.buildTime).toLocaleDateString('sr-Latn', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  return (
    <span>
      {data.stats.summary.totalResponses} odgovora · {data.stats.summary.totalQuotes} citata ·{' '}
      {data.stats.summary.opstine.length} opštine · poslednji build {date}
    </span>
  );
}

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-neutral-200 bg-neutral-50 py-8 text-sm text-neutral-600">
      <div className="mx-auto flex max-w-6xl flex-col gap-2 px-6 sm:flex-row sm:items-center sm:justify-between">
        <Suspense fallback={<span className="text-neutral-400">učitava se…</span>}>
          <BuildInfo />
        </Suspense>
        <div className="flex gap-4">
          <a href="/metodologija" className="link-quiet">Metodologija</a>
          <a href="/brojke" className="link-quiet">Brojke</a>
          <a href="/glasovi" className="link-quiet">Glasovi</a>
        </div>
      </div>
    </footer>
  );
}
